import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-506d6b02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_2 = {
  key: 0,
  class: "card-body pt-9 pb-0"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-share fs-24-px",
  style: {"color":"#dbdbdb","transform":"rotateY(180deg)"}
}, null, -1))
const _hoisted_4 = { class: "row pt-3" }
const _hoisted_5 = { class: "col-8" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-8" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "form-group row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "col-2 col-form-label"
}, [
  /*#__PURE__*/_createElementVNode("h5", null, "Name")
], -1))
const _hoisted_11 = { class: "col-10" }
const _hoisted_12 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_13 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_14 = { class: "row d-flex align-items-center" }
const _hoisted_15 = { class: "form-group row align-items-center" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "col-2 col-form-label"
}, [
  /*#__PURE__*/_createElementVNode("h5", null, "Group")
], -1))
const _hoisted_17 = { class: "col-7" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  disabled: ""
}, "Select a group", -1))
const _hoisted_19 = ["value"]
const _hoisted_20 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_21 = { class: "col-3" }
const _hoisted_22 = { class: "col-4" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "backgroundColor",
  class: "form-label"
}, [
  /*#__PURE__*/_createElementVNode("h5", { class: "m-0" }, "Background Color")
], -1))
const _hoisted_24 = {
  id: "colorPicker",
  class: "ml-3 mt-3 mb-3"
}
const _hoisted_25 = ["id", "onClick"]
const _hoisted_26 = {
  key: 0,
  class: "fa-regular fa-circle-check color-check"
}
const _hoisted_27 = { class: "row mt-5" }
const _hoisted_28 = { class: "col-12" }
const _hoisted_29 = { class: "form-group row" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "inputEmail3",
  class: "col-sm-1 col-form-label"
}, [
  /*#__PURE__*/_createElementVNode("h5", null, "Text")
], -1))
const _hoisted_31 = { class: "col-sm-11" }
const _hoisted_32 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_33 = { class: "col-4" }
const _hoisted_34 = { class: "row my-3" }
const _hoisted_35 = { class: "col-6" }
const _hoisted_36 = { class: "col-6" }
const _hoisted_37 = {
  class: "modal fade",
  tabindex: "-1",
  id: "addGroupModal"
}
const _hoisted_38 = { class: "modal-dialog" }
const _hoisted_39 = { class: "modal-content" }
const _hoisted_40 = { class: "modal-header" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Add a Group", -1))
const _hoisted_42 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" }, null, -1))
const _hoisted_44 = {
  class: "modal fade",
  tabindex: "-1",
  id: "editGroupModal"
}
const _hoisted_45 = { class: "modal-dialog" }
const _hoisted_46 = { class: "modal-content" }
const _hoisted_47 = { class: "modal-header" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Edit a Group", -1))
const _hoisted_49 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ListingTokens = _resolveComponent("ListingTokens")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_add_group = _resolveComponent("add-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.editTemplateObject)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_router_link, { to: "/notes/templates" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _createElementVNode("div", _hoisted_11, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            name: "name",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editTemplateObject.name) = $event)),
                            class: "form-control m-2 fw-boldest input-rounded",
                            id: "name"
                          }, null, 512), [
                            [_vModelText, _ctx.editTemplateObject.name]
                          ]),
                          (_ctx.isErrorEmpty)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Name is required."))
                            : _createCommentVNode("", true),
                          (_ctx.isErrorUnique)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Name must be unique."))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("div", _hoisted_17, [
                          _withDirectives(_createElementVNode("select", {
                            class: "mx-2 form-select fw-boldest input-rounded",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editTemplateObject.templateGroupId) = $event)),
                            id: "groupContainer"
                          }, [
                            _hoisted_18,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (grp, templateGroupId) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: templateGroupId,
                                value: grp.templateGroupId
                              }, _toDisplayString(grp.name), 9, _hoisted_19))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, _ctx.editTemplateObject.templateGroupId]
                          ]),
                          (_ctx.showGroupIsRequired)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Group is required."))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("i", {
                            class: "fas fa-plus customPlusIcon",
                            title: "Add Group",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addGroup()))
                          }),
                          _createElementVNode("i", {
                            class: "fas fa-pen customPlusIcon mx-1",
                            title: "Edit Group",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editGroup()))
                          })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("div", _hoisted_24, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colors, (color, index) => {
                        return (_openBlock(), _createElementBlock("button", {
                          type: "button",
                          class: "color-picker",
                          key: index,
                          id: color,
                          style: _normalizeStyle(`background-color: ${color};`),
                          onClick: ($event: any) => (_ctx.selectColor(color))
                        }, [
                          (color == _ctx.editTemplateObject.background)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_26))
                            : _createCommentVNode("", true)
                        ], 12, _hoisted_25))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("div", _hoisted_31, [
                        _withDirectives(_createElementVNode("textarea", {
                          class: "form-control fw-bolder",
                          id: "text",
                          style: {"height":"calc(100vh - 400px)"},
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editTemplateObject.text) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.editTemplateObject.text]
                        ]),
                        (_ctx.isTextErrorEmpty)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Text is required."))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_ListingTokens),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary m-1 float-end listing-tokens-buttons",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveTemplate()))
                    }, " Save changes ")
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-secondary m-1 float-end listing-tokens-buttons",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.close()))
                    }, " Close ")
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Close.svg" })
            ])
          ]),
          _createVNode(_component_add_group, {
            onUpdateGroups: _ctx.updateGroups,
            edit: false
          }, null, 8, ["onUpdateGroups"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_44, [
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Close.svg" })
            ])
          ]),
          (_ctx.groupToEdit)
            ? (_openBlock(), _createBlock(_component_add_group, {
                key: 0,
                onUpdateGroups: _ctx.updateGroups,
                edit: true,
                groupToEdit: _ctx.groupToEdit
              }, null, 8, ["onUpdateGroups", "groupToEdit"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}